import { h } from 'preact'
import { escapeHtml } from '../markdown'

export default function PropertyCards({ properties, searchSuffix }) {
  if (!properties || properties.length === 0) return null

  return (
    <div class="ml-9 mb-3 chat-message animate-slide-up">
      <div class="chat-property-cards">
        {properties.map(p => (
          <PropertyCard key={p.slug} property={p} searchSuffix={searchSuffix} />
        ))}
      </div>
    </div>
  )
}

// When a card image finishes loading it grows the message area; keep the
// view pinned to the newest message unless the user has scrolled up to read.
function keepPinnedToBottom(e) {
  const area = e.target.closest('.kailani-messages')
  if (!area) return
  const distanceFromBottom = area.scrollHeight - area.scrollTop - area.clientHeight
  if (distanceFromBottom < 250) {
    area.scrollTop = area.scrollHeight
  }
}

function PropertyCard({ property: p, searchSuffix }) {
  const features = []
  if (p.bedrooms) features.push(`${p.bedrooms} BR`)
  if (p.max_occupancy) features.push(`Sleeps ${p.max_occupancy}`)
  if (p.pet_friendly) features.push('\u{1F43E} Pets')
  if (p.hot_tub) features.push('♨️ Hot tub')

  const cardUrl = `/properties/${p.slug}${searchSuffix || ''}`

  return (
    <a
      href={cardUrl}
      class="chat-property-card"
      onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'chat_property_card_click', { slug: p.slug }) }}
    >
      {p.image_url ? (
        <img src={p.image_url} alt={p.name} class="chat-card-img" loading="lazy" onLoad={keepPinnedToBottom} />
      ) : (
        <div class="chat-card-img chat-card-img-placeholder">
          <svg class="w-5 h-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
          </svg>
        </div>
      )}
      <div class="chat-card-info">
        <div class="chat-card-name">
          {p.name}
          {p.review_score ? <span class="chat-card-rating"> ★ {p.review_score}</span> : null}
        </div>
        <div class="chat-card-features">{features.join(' · ')}</div>
      </div>
    </a>
  )
}
